export default __webpack_public_path__ + "static/media/Dimshade Straps.afc6ee5f.jpg";